import { http } from "../http";

export const createWithdrawTicketHTTP = async data => {
  return http.post("CreateWithdrawTicket", data);
};
export const getWithdrawTicketsHTTP = async data => {
  return http.post("GetWithdrawTickets", data);
};
